import {Row, Col, Form, Button, Alert} from "react-bootstrap";
import {useEffect, useState} from "react";
import axios from 'axios';
import localforage from 'localforage';
import './App.css';
import logo from './assets/6.svg';
import icon1 from './assets/1.svg';
import icon2 from './assets/2.svg';
import icon3 from './assets/3.svg';
import icon4 from './assets/4.svg';
import icon5 from './assets/5.svg';
import config, {appVersion} from "./config";

const {baseUrl, groupUrl, vendorUrl} = config;

const USER_TYPE = {
    PLATFORM: 'PLATFORM',
    VENDOR: 'VENDOR',
    GROUP: 'GROUP'
}

const localConfig = {
    name: '云科室',
    storeName: 'yksPersist'
}
const localforageKey = `persist:auth`;

localforage.config({
    driver: localforage.LOCALSTORAGE,
    name: localConfig.name,
    storeName: localConfig.storeName
})

function App() {

    const [username, setUsername] = useState('');
    const [usernameErr, setUsernameErr] = useState(false);
    const [password, setPassword] = useState('');
    const [passwordErr, setPasswordErr] = useState(false);
    const [loginErr, setLoginErr] = useState(null);

    useEffect(() => {
        localforage.getItem(localforageKey).then((v) => {
            if (v) {
                const _v = JSON.parse(v);
                if (_v && _v.data) {
                    const tokenData = JSON.parse(_v.data);
                    if (tokenData) checkUser(tokenData);
                }
            }
        })
    }, [])

    const usernameChange = (e) => {
        const value = e.target.value;
        setUsername(value);
        setLoginErr(null);
        if (value === '') {
            setUsernameErr(true);
        } else {
            setUsernameErr(false);
        }
    }

    const passwordChange = (e) => {
        const value = e.target.value;
        setPassword(value);
        setLoginErr(null);
        if (value === '') {
            setPasswordErr(true);
        } else {
            setPasswordErr(false);
        }
    }

    const handleKeyPress = (e) => {
        if (e.keyCode !== 13) return
        handleLogin();
    }

    const handleLogin = () => {
        setLoginErr(null);
        if (!username || username === '') {
            return
        }
        if (!password || password === '') {
            return
        }
        axios({
            method: 'post',
            url: `${baseUrl}/era/token`,
            data: {
                username,
                password
            }
        }).then((res) => {
            if (res && res.data) {
                localforage.setItem(localforageKey, JSON.stringify({data: JSON.stringify(res.data)}));
                checkUser(res.data);
            }
        }).catch((err) => {
            let msg = '登录发生错误';
            if (err && err.response && err.response.data && err.response.data.errorMessage) {
                msg = err.response.data.errorMessage
            }
            setLoginErr(msg);
        })
    }

    const checkUser = (tokenData) => {
        const {tokenType, accessToken} = tokenData;
        axios({
            method: 'get',
            url: `${baseUrl}/era/users/me`,
            headers: {
                Authorization: `${tokenType} ${accessToken}`
            }
        }).then((res) => {
            if (res && res.data) {
                const {type} = res.data;
                const protocol = window.location.protocol;
                if (type === USER_TYPE.GROUP) {
                    window.location.href = `${protocol}${groupUrl}`;
                    return
                }
                if (type === USER_TYPE.VENDOR) {
                    window.location.href = `${protocol}${vendorUrl}`;
                    return;
                }
                setLoginErr('非基层医院/医生集团账户');
                clearItem();
            }
        }).catch((err) => {
            clearItem();
            if (err && err.response) {
                if (err.response.status === 401) {
                    return setLoginErr('登陆信息已过期，请重新登陆');
                }
            }
            setLoginErr('登陆失败');
        })
    }

    const clearItem = () => {
        localforage.removeItem(localforageKey)
    }

    return (
        <div className="badger-login">
            <header className='badger-login-header'>
                <img src={logo} alt="logo"/>
            </header>
            <div className='badger-login-body'>
                <Row className='badger-login-content'>
                    <Col md={8}>
                        <Row className='badger-login-content-title'>
                            <h2>云上医院</h2>
                        </Row>
                        <Row>
                            <Col md={3}/>
                            <Col md={6}>
                                <h4>云图医疗致力于为医疗机构提供以云计算和人工智能技术为支持的"云上医院"综合解决方案</h4>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3}/>
                            <Col md={2} align='center' className='badger-login-body-icons'>
                                <img src={icon1}/>
                                <p>云医院（院内）</p>
                            </Col>
                            <Col md={2} align='center' className='badger-login-body-icons'>
                                <img src={icon2}/>
                                <p>助医帮（赋能）</p>
                            </Col>
                            <Col md={2} align='center' className='badger-login-body-icons'>
                                <img src={icon3}/>
                                <p>云上就医（链接）</p>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={3}>
                        <div className='badger-login-form'>
                            <h3>用户登录</h3>
                            <Form horizontal='true'>
                                <Row>
                                    <Col md={1}/>
                                    <Col md={10}>
                                        <div className='badger-input-box'>
                                            <span><img src={icon4}/></span>
                                            <input type="text"
                                                   value={username}
                                                   placeholder="请输入账号"
                                                   onChange={usernameChange}
                                                   onKeyUp={handleKeyPress}/>
                                        </div>
                                    </Col>
                                </Row>
                                {
                                    usernameErr &&
                                    <Row style={{fontSize: '12px', color: 'red'}}>
                                        <Col md={1}/>
                                        <Col md={10} align='left'>请输入账号</Col>
                                    </Row>
                                }
                                <Row style={{marginTop: '10px'}}>
                                    <Col md={1}/>
                                    <Col md={10}>
                                        <div className='badger-input-box'>
                                            <span><img src={icon5}/></span>
                                            <input type="password"
                                                   value={password}
                                                   placeholder="请输入密码"
                                                   onChange={passwordChange}
                                                   onKeyUp={handleKeyPress}/>
                                        </div>

                                    </Col>
                                </Row>
                                {
                                    passwordErr &&
                                    <Row style={{fontSize: '12px', color: 'red'}}>
                                        <Col md={1}/>
                                        <Col md={10} align='left'>请输入密码</Col>
                                    </Row>
                                }
                                <Row style={{marginTop: '20px', marginBottom: '25px'}}>
                                    <Col md={1}>
                                    </Col>
                                    <Col md={10}>
                                        <Button block className='badger-login-form-btn'
                                                onClick={handleLogin}>
                                            登录
                                        </Button>
                                    </Col>
                                </Row>
                                {
                                    loginErr &&
                                    <Row>
                                        <Col md={1}>
                                        </Col>
                                        <Col md={10}>
                                            <Alert variant="danger">
                                                {loginErr}
                                            </Alert>
                                        </Col>
                                    </Row>
                                }
                            </Form>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className='badger-login-footer'>
                <p>©2021 苏州云图医疗科技有限公司 苏ICP备2020067357号 v.{appVersion}</p>
            </div>
        </div>
    );
}

export default App;
